import { LocalTournamentPlace } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';
import { WinnerTournamentContent } from './components/WinnerTournamentContent';
import { ResponsiveModalWrapper } from 'src/components/ResponsiveModalWrapper';

type ModalProps = {
  prize: LocalTournamentPlace;
  tournamentName: string;
};

export const WinnerTournamentModal = () => {
  const { modalProps } = useModalContext<ModalProps>();

  const modalContent = (
    <WinnerTournamentContent
      prize={modalProps?.prize}
      tournamentName={modalProps?.tournamentName}
    />
  );

  return (
    <ResponsiveModalWrapper
      isTransparentBg
      className="max-w-[500px] w-full"
      containerClassName="bg-WINNER_TOURNAMENT_BG p-5 rounded-[20px] flex flex-col items-center gap-2"
      containerClassNameMobile="bg-WINNER_TOURNAMENT_BG p-5 rounded-t-[20px] flex flex-col items-center gap-2"
      showCross={false}>
      {modalContent}
    </ResponsiveModalWrapper>
  );
};
